import * as React from 'react';
import { Alert, AlertDescription, AlertIcon } from '@chakra-ui/react';
import UploadButtonSection from '../../atoms/upload-button-section';
import UploadActions from '../../atoms/upload-actions';

interface Props {
  fileNames: string[];
  onUpload: () => void;
  onContinue: () => void;
}

const UploadCompleteSection: React.FC<Props> = (props: Props) => {
  return (
    <>
      <Alert status="success" data-selector="uploaded-files" mb={6}>
        <AlertIcon />

        <AlertDescription>
          {props.fileNames ? props.fileNames.length : '0'} file(s) successfully uploaded
        </AlertDescription>
      </Alert>

      <UploadButtonSection onUpload={props.onUpload} complete={true}>
        Upload additional files?
      </UploadButtonSection>

      <UploadActions complete={true} label="Return to document upload" onContinue={props.onContinue} />
    </>
  );
};

export default UploadCompleteSection;
